import type { ReactNode } from 'react';

export function PageHeader({
  breadcrumbs,
  description,
  title,
  actions,
}: {
  breadcrumbs?: ReactNode;
  description?: ReactNode;
  title: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div className="page-header__content">
        {breadcrumbs ? <div className="page-breadcrumbs">{breadcrumbs}</div> : null}
        <h1>{title}</h1>
        {description ? <p className="page-header__description">{description}</p> : null}
      </div>
      {actions ? <div className="page-toolbar">{actions}</div> : null}
    </header>
  );
}
